export default __webpack_public_path__ + "static/media/postger.4776707e.svg";